import { useState } from "react";

export const useForm = (initialValue) => {
  const [values, setValues] = useState(initialValue);

  return [
    values,
    (value, action) => {
      setValues({
        ...values,
        [action.name]: value,
      });
    },
  ];
};

export default useForm;
